export default {
  personGender(person) {
    if (!person) return null;
    return person.gender || (person.userProfile && person.userProfile.gender) || null;
  },
  parentRole(person) {
    return this.ancestorRole(0, person);
  },
  childRole(person) {
    return this.descendantRole(0, person);
  },
  ancestorTitle(depth) {
    if (depth === 0) return 'Родители';
    if (depth === 1) return 'Бабушки и дедушки';
    if (depth === 2) return 'Прабабушки и прадедушки';
    return 'Предки';
  },
  descendantTitle(depth) {
    if (depth === 0) return 'Дети';
    if (depth === 1) return 'Внуки';
    if (depth === 2) return 'Правнуки';
    return 'Потомки';
  },
  ancestorRole(depth, person) {
    const gender = this.personGender(person);
    if (depth === 0) {
      if (gender === 'male') return 'Отец';
      if (gender === 'female') return 'Мать';
      return 'Родитель';
    }
    if (depth === 1) {
      if (gender === 'male') return 'Дедушка';
      if (gender === 'female') return 'Бабушка';
      return 'Прародитель';
    }
    if (depth === 2) {
      if (gender === 'male') return 'Прадедушка';
      if (gender === 'female') return 'Прабабушка';
      return 'Предок';
    }
    return 'Предок';
  },
  descendantRole(depth, person) {
    const gender = this.personGender(person);
    if (depth === 0) {
      if (gender === 'male') return 'Сын';
      if (gender === 'female') return 'Дочь';
      return 'Ребёнок';
    }
    if (depth === 1) {
      if (gender === 'male') return 'Внук';
      if (gender === 'female') return 'Внучка';
      return 'Внук / внучка';
    }
    if (depth === 2) {
      if (gender === 'male') return 'Правнук';
      if (gender === 'female') return 'Правнучка';
      return 'Потомок';
    }
    return 'Потомок';
  },
  isSpousePair(a, b) {
    const aSpouseId = a && a.mariedUser && a.mariedUser.id;
    const bSpouseId = b && b.mariedUser && b.mariedUser.id;
    return !!(aSpouseId && bSpouseId && aSpouseId === b.id && bSpouseId === a.id);
  },
}
